var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Card from 'src/components/Card/Card.vue';
import FilesUploader from 'src/components/FileUploader/FilesUploader';
import { getKeyHash } from 'src/utils/encryption/getKeyHash';
import Preferences from 'src/store/preferences/Preferences.vue';
import UserPreferences from 'src/store/preferences/UserPreferences.vue';
import { getActingUser, setActingUser } from 'src/utils/actingUser';
import isDevelopmentEnvironment from 'src/utils/developer/isDevEnvironment';
import Button from 'src/components/Button/Button';
// import { getMicrosoftAuthUrlFromDefaultParams } from 'src/utils/oauth'
import { getTestButtonProps } from 'src/utils/notification/testButtonProps';
import rpc from 'src/api/rpc';
import Form from 'src/components/Form/Form.vue';
import { getSendEmailTestFormProps } from 'src/platform/integrations/email/9_test/getSendEmailTestFormProps';
export default Vue.extend({
    components: { Card, Preferences, FilesUploader, Form, UserPreferences, Button },
    data() {
        return {
            password: null,
            current_password: null,
            password_confirmation: null,
            tenantEncryptionKeysString: '',
            tenantEncryptionKeysStringSv: ''
        };
    },
    computed: {
        connectMicrosoftAccountButtonProps() {
            return {
                buttonListeners: {
                    click: () => __awaiter(this, void 0, void 0, function* () {
                        var _a;
                        // if (!this.hasOauthConnectedFor('microsoft')) {
                        const urlData = yield rpc('integrations.generate_oauth_url', { provider: 'microsoft' });
                        if ((_a = urlData === null || urlData === void 0 ? void 0 : urlData.data) === null || _a === void 0 ? void 0 : _a.url) {
                            window.location = urlData.data.url;
                        }
                        // }
                    })
                },
                buttonProps: {
                    // label: this.hasOauthConnectedFor('microsoft') ? 'Microsoft account connected' : 'Connect Microsoft account',
                    label: 'Connect Microsoft account',
                    unelevated: true,
                },
                tooltipProps: {
                    tooltipContent: 'This feature is not yet implemented'
                }
            };
        },
        fileUploaderProps() {
            return {
                destination: { destination_type: 'platform' }
            };
        },
        actingUserObject() { return getActingUser() || {}; },
    },
    created() {
        this.initializeEncryptionKeys();
    },
    methods: {
        isDevelopmentEnvironment,
        setActingUser(user) {
            setActingUser(user);
        },
        getTestButtonProps,
        getSendEmailTestFormProps,
        hasOauthConnectedFor(provider) {
            var _a;
            return !!((_a = this.actingUserObject.oauth_objects) === null || _a === void 0 ? void 0 : _a.find(oauth => oauth.provider === provider));
        },
        getTenantEncryptionKeys() {
            const lsTeks = localStorage.getItem('tenantEncryptionKeys');
            if (!lsTeks)
                return '';
            const teks = JSON.parse(lsTeks);
            if (!teks || (!teks.encryptionKey && !teks.decryptionKeys))
                return '';
            let res = '';
            const ek = teks.encryptionKey;
            res += ek;
            for (const keyhash in teks.decryptionKeys) {
                const keystr = teks.decryptionKeys[keyhash];
                if (ek !== keystr)
                    res += ('\n' + keystr);
            }
            return res;
        },
        handleChangeOfTenantEncryptionKeys() {
            const val = this.tenantEncryptionKeysString;
            const lines = val.split('\n');
            const linesLen = lines.length;
            if (linesLen === 0)
                return;
            const teks = { encryptionKey: '', decryptionKeys: {} };
            if (lines[0].length > 0)
                teks.encryptionKey = lines[0];
            for (let i = 0; i < linesLen; i++) {
                const keystr = lines[i];
                if (keystr.length === 0)
                    break;
                const hash = getKeyHash(keystr);
                teks.decryptionKeys[hash] = keystr;
            }
            localStorage.setItem('tenantEncryptionKeys', JSON.stringify(teks));
            this.initializeEncryptionKeys();
        },
        updateOwnPassword() {
            return __awaiter(this, void 0, void 0, function* () {
                const creds = { user: { current_password: this.current_password, password: this.password, password_confirmation: this.password_confirmation } };
                const success = yield this.$store.dispatch('authorizedUser/updateOwnPassword', { creds, ctx: this });
                if (success !== true)
                    this.$q.notify({ message: 'Failed to update your password. Please make sure that you entered correct "current password" and new password and confirmation match.', type: 'negative' });
                this.resetFields();
            });
        },
        resetFields() {
            this.password = null;
            this.current_password = null;
            this.password_confirmation = null;
        },
        doLogout() {
            this.$store.dispatch('authorizedUser/doLogout');
            // probably should also warn a user about existing OAuth connection and necessity of logging out from those providers
            // we can direct user to the logout url with the 'redirect_url' specified in the params to where user will be redirected after logging out,
            // so that, theoretically, we can form a chain of redirections to the logout urls
            // of OAuth providers, i.e. microsoft/loout -> google/logout -> facebook/logout, etc.
        },
        initializeEncryptionKeys() {
            const teks = this.getTenantEncryptionKeys();
            this.tenantEncryptionKeysString = teks;
            this.tenantEncryptionKeysStringSv = this.tenantEncryptionKeysString;
        },
        filesUploaded(result) {
            // console.log('Successfully uploaded files', result)
        }
    }
});
